"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;
//# sourceMappingURL=media.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/constants/media.js
// module id = 366
// module chunks = 79611799117203 213534597649335